//Direct URL Loading Tab Switching Functionality
var pageUpdated = false;

$(document).ready(function(){

  listFbLike();
  var elementId=$("input[name=metaCode]:checked").attr('id');
  $("input[name=metaCode]:checked").closest('table').find('th, td').removeClass('selected');
  $("input[name=metaCode]:checked").closest('table').find('.'+elementId).addClass('selected');  //Highlighting Stateoom selection
	//Tab Switching Functionality
	$('#tabs a').click(function(event){
		event.preventDefault(); 		
		$('#tabs a').removeClass('active');		
		$(this).addClass('active');
		var tabId=$(this).attr('id');
		$("input[type=hidden][name=currentPage]").val($(this).attr('href'));	
		var url = $(this).attr('href');
		if( url.indexOf('flightsDetails.do?') == -1 ){
        	url += "?"+ getDynamicUserSelections();	
		}		
		
		ajaxCallback(url,'tab-content',c, 'cruiseDetails');		
		function c(){//callback
			if(tabId=='CompareDatesAndFares'){
				var elementId=$("input[name=metaCode]:checked").attr('id');
				$('.pricing-details-table .'+elementId ).addClass('highlighted-meta');
			}
			if(tabId=='exList'){
				no_excursions_selected();
			}
			if(tabId=='Itinerary'){
				cruiseDetails.missingMapImg();
			}	
			var destination = $('#promo-slot').offset().top;
			$("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination}, 1500, function() {			
				window.location.hash = url;
			});		
	  	}		 
	   return false;
	});
	 
	//Highlighting Stateoom selection
	$(document).on('change', '#stateroom-type input', function(){
		var elementId=$(this).attr('id');
		$(this).closest('table').find('th, td').removeClass('selected');
		$(this).closest('table').find('.'+elementId).addClass('selected');
		$(this).attr('checked', true);

		
		$('#compare-dates-fares .pricing-details-table td').removeClass('highlighted-meta');
		$('#compare-dates-fares .pricing-details-table .'+elementId ).addClass('highlighted-meta');
		$('#selectedMeta').val($('#'+elementId).val());
	});
	
	$(document).on('click', '#stateroom-type td', function(){
		var colIndex = $(this).parent().children().index($(this))+1;
		var stateroomTypeInput = $(this).closest('table').find("th:nth-child("+colIndex+") input[name=metaCode]");
		if( !stateroomTypeInput.prop("disabled") ){
			stateroomTypeInput.trigger('change');
		}
	})
	
	adjustStateRoomTypeHeight();
	$(document).on('click', '.sign-in-register-link', function(e) {
		e.preventDefault();
		$('#signin-signout').find('a').click();
	});

});


function adjustStateRoomTypeHeight(){
	// Adjusting height of Stateroom selection box
	var maxHeight = 0;		
	$('.stateroom-type').each(function(){		
		maxHeight = Math.max(maxHeight, $(this).height());
	});
	$('.stateroom-type').css('height',maxHeight);	
}

function ajaxCallback(urls,elemId,func,frmName){
	var formData='';
	if(frmName != null && frmName.length >0){
		formData=$("#"+frmName).serialize();
	}
	$.ajax({ 
		type: "POST", 
		url: urls, 
		dataType: "html", 
		data: formData, 
		global: false,
		success: function(s){     
			$("#"+elemId).html(s);
			pageUpdated = true;
			if($.isFunction(func)){
				func.call();
			}
		}, 
		error: function(e) { 
			$("#"+elemId).html("Unable to process now. Please try later.");
		} 
  });
}

function openLegalTerms(){
  window.open(getWWWUrl(getUrl())+'legal/passage_contract/index.jsp', 'legal_terms');
}

function openUBELegalTerms(bId,isBestFare,country){
  if(isBestFare == 'true') {
    window.open(getWWWUrl(getUrl())+'legal/passage_contract/index.jsp', 'legal_terms');
  } else {
    window.open(getWWWUrl(getUrl()) + 'legal/passage_contract/passage_contract_'+bId+'.jsp?con='+country, 'ta_rates_footer');
  }
}

$(document).on('mouseover mouseout', '.show-tooltip', function(event){
	if( event.type == 'mouseover' ){
		$('.tooltip').css({'left':'-2000px','top':'-2000px'});
		$('.tooltip').removeClass().addClass('tooltip');
		var $this = $(this);
		var thisHeight =0;
		// If the element has children, calculate that height too.
		if($this.children().length){
			thisHeight= $this.contents().outerHeight();
		}
		else{
			thisHeight= 10;
		}

		var tooltipColor= $this.attr('data-tooltip');
		$('.tooltip').addClass(tooltipColor+'-tooltip');
		var tooltipContent =$this.attr('data-tooltip-content');
		tooltipContent = "#"+tooltipContent;
		var tooltipHeading= $(tooltipContent +' h2').text();
		$('#tooltip-content').prev('h2').text(tooltipHeading);
		tooltipContent = $(tooltipContent +" .tooltip-inner-content").html();

		$('#tooltip-content').html(tooltipContent);				
		var elemOffsetPosition = $this.offset();
		var elemWidth = $this.outerWidth();
		var tooltipWidth= $('.tooltip').outerWidth();
		var tooltipHeight= $('.tooltip').outerHeight();
		$('.tooltip').delay(100).show(0,function(){
			$('.tooltip').offset({
				'left': elemOffsetPosition.left - tooltipWidth + elemWidth + 5,
				'top': elemOffsetPosition.top - tooltipHeight - thisHeight
			});
			var tooltipOffset = $('.tooltip').offset();
			var contentDivOffset = $('#content').offset();
			//Reset the Tooltip Position
			$('.tooltip .pointer-arrow').css({'left':'auto', 'right':'5px'});	
			//Re-position Tooltip if it is bleeds beyond the content area
			if(contentDivOffset.left > tooltipOffset.left){
				$('.tooltip').offset({
					'left': elemOffsetPosition.left
				});
				$('.tooltip .pointer-arrow').css({'left':'0px', 'right':'auto'});
			}

			$('.tooltip').hover(function(){
				$(this).show();
			},
			function(){
				$(this).hide();
			}
			);
		});
	}
	else{
		$('.tooltip').stop(true, true).hide();	 
	}
}
);
	
